// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/catalog.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BatchReviewImportReviewsRequest, BatchReviewImportReviewsResponse, BulkConfirmMappingsRequest, BulkConfirmMappingsResponse, BulkSetPropertiesRequest, BulkSetPropertiesResponse, BulkUpdateProductsRequest, BulkUpdateProductsResponse, ConfirmProductMappingRequest, ConfirmProductMappingResponse, CreateCategoryRequest, CreateProductRequest, CreatePropertyDefinitionRequest, CreatePropertyGroupRequest, CreateSalesChannelRequest, CreateSearchSynonymRequest, CreateSupplierDraftRequest, CreateVariantRequest, CrossReferenceRequest, CrossReferenceResponse, CustomerPricingRule, DeleteAllCategoriesRequest, DeleteAllCategoriesResponse, DeleteAllProductsRequest, DeleteAllProductsResponse, DeleteCategoryRequest, DeleteProductLocaleRequest, DeleteProductRequest, DeletePropertyDefinitionRequest, DeletePropertyGroupRequest, DeleteSalesChannelRequest, DeleteSearchSynonymRequest, DismissProductMappingRequest, EnrichProductRequest, EnrichProductResponse, ExportCatalogRequest, ExportCatalogResponse, ExportProductsExcelRequest, ExportProductsExcelResponse, ExportToChannelRequest, ExportToChannelResponse, FinalizeCatalogImportRequest, FinalizeCatalogImportResponse, GetCatalogCompletenessRequest, GetCatalogCompletenessResponse, GetCompetitorInsightsRequest, GetCompetitorInsightsResponse, GetCustomerPricingRuleRequest, GetEnrichmentStatsRequest, GetEnrichmentStatsResponse, GetFieldPermissionsRequest, GetFieldPermissionsResponse, GetProductEnrichmentHistoryRequest, GetProductEnrichmentHistoryResponse, GetProductRequest, GetProductVersionsRequest, GetProductVersionsResponse, GetPropertyDefinitionRequest, GetSearchIndexStatsRequest, GetSearchIndexStatsResponse, GetSearchSettingsRequest, GroupProductsRequest, GroupProductsResponse, ImportCatalogRequest, ImportCatalogResponse, ImportProductRequest, ImportProductResponse, ImportProductsExcelRequest, ImportProductsExcelResponse, ImportSearchSynonymsRequest, ImportSearchSynonymsResponse, ImportYandexFeedMediaRequest, ImportYandexFeedMediaResponse, ImportYandexFeedRequest, ImportYandexFeedResponse, ListBundleItemsRequest, ListBundleItemsResponse, ListCategoriesRequest, ListCategoriesResponse, ListCategoryPropertiesRequest, ListCategoryPropertiesResponse, ListChannelMappingsRequest, ListChannelMappingsResponse, ListClassificationCodesRequest, ListClassificationCodesResponse, ListClassificationStandardsRequest, ListClassificationStandardsResponse, ListImportReviewsRequest, ListImportReviewsResponse, ListProductLocalesRequest, ListProductLocalesResponse, ListProductMappingsRequest, ListProductMappingsResponse, ListProductsRequest, ListProductsResponse, ListPropertyDefinitionsRequest, ListPropertyDefinitionsResponse, ListPropertyGroupsRequest, ListPropertyGroupsResponse, ListSalesChannelsRequest, ListSalesChannelsResponse, ListSearchSynonymsRequest, ListSearchSynonymsResponse, ListSupplierDraftsRequest, ListSupplierDraftsResponse, ListVariantsRequest, ListVariantsResponse, MoveCategoryRequest, PreviewCustomerPricingRequest, PreviewCustomerPricingResponse, ProcessCatalogImportRequest, ProcessCatalogImportUpdate, Product, ProductCategory, ProductLocale, PropertyDefinition, PropertyDefinitionGroup, RestoreProductVersionRequest, ReviewImportReviewRequest, ReviewImportReviewResponse, ReviewSupplierDraftRequest, ReviewSupplierDraftResponse, SalesChannel, SearchBrandsRequest, SearchBrandsResponse, SearchImportReviewAlternativesRequest, SearchSettings, SearchSynonym, SetBundleItemsRequest, SetBundleItemsResponse, SetCategoryPropertiesRequest, SetCategoryPropertiesResponse, SetChannelMappingsRequest, SetChannelMappingsResponse, SetCustomerPricingRuleRequest, SetFieldPermissionsRequest, SetFieldPermissionsResponse, SetProductClassificationsRequest, SetProductClassificationsResponse, SetProductLocaleRequest, SetVariationAxesRequest, SetVariationAxesResponse, SuggestProductMappingsRequest, SuggestProductMappingsResponse, SuggestVariationGroupsRequest, SuggestVariationGroupsResponse, SupplierProductDraft, SyncSearchSynonymsRequest, SyncSearchSynonymsResponse, UngroupProductRequest, UpdateCategoryRequest, UpdateProductRequest, UpdatePropertyDefinitionRequest, UpdateSalesChannelRequest, UpdateSearchSettingsRequest, UpdateSearchSynonymRequest } from "./catalog_pb.js";
import { Empty, MethodKind } from "@bufbuild/protobuf";
import { SearchAlternativesResponse } from "./work_item_pb.js";

/**
 * @generated from service omnios.v1.CatalogService
 */
export const CatalogService = {
  typeName: "omnios.v1.CatalogService",
  methods: {
    /**
     * @generated from rpc omnios.v1.CatalogService.CreateProduct
     */
    createProduct: {
      name: "CreateProduct",
      I: CreateProductRequest,
      O: Product,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.GetProduct
     */
    getProduct: {
      name: "GetProduct",
      I: GetProductRequest,
      O: Product,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.UpdateProduct
     */
    updateProduct: {
      name: "UpdateProduct",
      I: UpdateProductRequest,
      O: Product,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.DeleteProduct
     */
    deleteProduct: {
      name: "DeleteProduct",
      I: DeleteProductRequest,
      O: Product,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ListProducts
     */
    listProducts: {
      name: "ListProducts",
      I: ListProductsRequest,
      O: ListProductsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.DeleteAllProducts
     */
    deleteAllProducts: {
      name: "DeleteAllProducts",
      I: DeleteAllProductsRequest,
      O: DeleteAllProductsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.BulkUpdateProducts
     */
    bulkUpdateProducts: {
      name: "BulkUpdateProducts",
      I: BulkUpdateProductsRequest,
      O: BulkUpdateProductsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.BulkImportProducts
     */
    bulkImportProducts: {
      name: "BulkImportProducts",
      I: ImportProductRequest,
      O: ImportProductResponse,
      kind: MethodKind.ClientStreaming,
    },
    /**
     * Variations
     *
     * @generated from rpc omnios.v1.CatalogService.CreateVariant
     */
    createVariant: {
      name: "CreateVariant",
      I: CreateVariantRequest,
      O: Product,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.SetVariationAxes
     */
    setVariationAxes: {
      name: "SetVariationAxes",
      I: SetVariationAxesRequest,
      O: SetVariationAxesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ListVariants
     */
    listVariants: {
      name: "ListVariants",
      I: ListVariantsRequest,
      O: ListVariantsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.GroupProducts
     */
    groupProducts: {
      name: "GroupProducts",
      I: GroupProductsRequest,
      O: GroupProductsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.UngroupProduct
     */
    ungroupProduct: {
      name: "UngroupProduct",
      I: UngroupProductRequest,
      O: Product,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.SuggestVariationGroups
     */
    suggestVariationGroups: {
      name: "SuggestVariationGroups",
      I: SuggestVariationGroupsRequest,
      O: SuggestVariationGroupsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.CreateCategory
     */
    createCategory: {
      name: "CreateCategory",
      I: CreateCategoryRequest,
      O: ProductCategory,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.UpdateCategory
     */
    updateCategory: {
      name: "UpdateCategory",
      I: UpdateCategoryRequest,
      O: ProductCategory,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.DeleteCategory
     */
    deleteCategory: {
      name: "DeleteCategory",
      I: DeleteCategoryRequest,
      O: ProductCategory,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.MoveCategory
     */
    moveCategory: {
      name: "MoveCategory",
      I: MoveCategoryRequest,
      O: ProductCategory,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ListCategories
     */
    listCategories: {
      name: "ListCategories",
      I: ListCategoriesRequest,
      O: ListCategoriesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.DeleteAllCategories
     */
    deleteAllCategories: {
      name: "DeleteAllCategories",
      I: DeleteAllCategoriesRequest,
      O: DeleteAllCategoriesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ImportYandexFeed
     */
    importYandexFeed: {
      name: "ImportYandexFeed",
      I: ImportYandexFeedRequest,
      O: ImportYandexFeedResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ImportYandexFeedMedia
     */
    importYandexFeedMedia: {
      name: "ImportYandexFeedMedia",
      I: ImportYandexFeedMediaRequest,
      O: ImportYandexFeedMediaResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Catalog import from documents
     *
     * @generated from rpc omnios.v1.CatalogService.ProcessCatalogImport
     */
    processCatalogImport: {
      name: "ProcessCatalogImport",
      I: ProcessCatalogImportRequest,
      O: ProcessCatalogImportUpdate,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.FinalizeCatalogImport
     */
    finalizeCatalogImport: {
      name: "FinalizeCatalogImport",
      I: FinalizeCatalogImportRequest,
      O: FinalizeCatalogImportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ListImportReviews
     */
    listImportReviews: {
      name: "ListImportReviews",
      I: ListImportReviewsRequest,
      O: ListImportReviewsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ReviewImportReview
     */
    reviewImportReview: {
      name: "ReviewImportReview",
      I: ReviewImportReviewRequest,
      O: ReviewImportReviewResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.BatchReviewImportReviews
     */
    batchReviewImportReviews: {
      name: "BatchReviewImportReviews",
      I: BatchReviewImportReviewsRequest,
      O: BatchReviewImportReviewsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.SearchImportReviewAlternatives
     */
    searchImportReviewAlternatives: {
      name: "SearchImportReviewAlternatives",
      I: SearchImportReviewAlternativesRequest,
      O: SearchAlternativesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Property definitions
     *
     * @generated from rpc omnios.v1.CatalogService.CreatePropertyDefinition
     */
    createPropertyDefinition: {
      name: "CreatePropertyDefinition",
      I: CreatePropertyDefinitionRequest,
      O: PropertyDefinition,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.UpdatePropertyDefinition
     */
    updatePropertyDefinition: {
      name: "UpdatePropertyDefinition",
      I: UpdatePropertyDefinitionRequest,
      O: PropertyDefinition,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.GetPropertyDefinition
     */
    getPropertyDefinition: {
      name: "GetPropertyDefinition",
      I: GetPropertyDefinitionRequest,
      O: PropertyDefinition,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.DeletePropertyDefinition
     */
    deletePropertyDefinition: {
      name: "DeletePropertyDefinition",
      I: DeletePropertyDefinitionRequest,
      O: PropertyDefinition,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ListPropertyDefinitions
     */
    listPropertyDefinitions: {
      name: "ListPropertyDefinitions",
      I: ListPropertyDefinitionsRequest,
      O: ListPropertyDefinitionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Category-property links
     *
     * @generated from rpc omnios.v1.CatalogService.SetCategoryProperties
     */
    setCategoryProperties: {
      name: "SetCategoryProperties",
      I: SetCategoryPropertiesRequest,
      O: SetCategoryPropertiesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ListCategoryProperties
     */
    listCategoryProperties: {
      name: "ListCategoryProperties",
      I: ListCategoryPropertiesRequest,
      O: ListCategoryPropertiesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Search index stats
     *
     * @generated from rpc omnios.v1.CatalogService.GetSearchIndexStats
     */
    getSearchIndexStats: {
      name: "GetSearchIndexStats",
      I: GetSearchIndexStatsRequest,
      O: GetSearchIndexStatsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Brand search
     *
     * @generated from rpc omnios.v1.CatalogService.SearchBrands
     */
    searchBrands: {
      name: "SearchBrands",
      I: SearchBrandsRequest,
      O: SearchBrandsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Search synonyms
     *
     * @generated from rpc omnios.v1.CatalogService.CreateSearchSynonym
     */
    createSearchSynonym: {
      name: "CreateSearchSynonym",
      I: CreateSearchSynonymRequest,
      O: SearchSynonym,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.UpdateSearchSynonym
     */
    updateSearchSynonym: {
      name: "UpdateSearchSynonym",
      I: UpdateSearchSynonymRequest,
      O: SearchSynonym,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.DeleteSearchSynonym
     */
    deleteSearchSynonym: {
      name: "DeleteSearchSynonym",
      I: DeleteSearchSynonymRequest,
      O: SearchSynonym,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ListSearchSynonyms
     */
    listSearchSynonyms: {
      name: "ListSearchSynonyms",
      I: ListSearchSynonymsRequest,
      O: ListSearchSynonymsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Search settings
     *
     * @generated from rpc omnios.v1.CatalogService.GetSearchSettings
     */
    getSearchSettings: {
      name: "GetSearchSettings",
      I: GetSearchSettingsRequest,
      O: SearchSettings,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.UpdateSearchSettings
     */
    updateSearchSettings: {
      name: "UpdateSearchSettings",
      I: UpdateSearchSettingsRequest,
      O: SearchSettings,
      kind: MethodKind.Unary,
    },
    /**
     * Sync synonyms to Typesense
     *
     * @generated from rpc omnios.v1.CatalogService.SyncSearchSynonyms
     */
    syncSearchSynonyms: {
      name: "SyncSearchSynonyms",
      I: SyncSearchSynonymsRequest,
      O: SyncSearchSynonymsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Batch import synonyms from CSV
     *
     * @generated from rpc omnios.v1.CatalogService.ImportSearchSynonyms
     */
    importSearchSynonyms: {
      name: "ImportSearchSynonyms",
      I: ImportSearchSynonymsRequest,
      O: ImportSearchSynonymsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Enrichment
     *
     * @generated from rpc omnios.v1.CatalogService.EnrichProduct
     */
    enrichProduct: {
      name: "EnrichProduct",
      I: EnrichProductRequest,
      O: EnrichProductResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.GetEnrichmentStats
     */
    getEnrichmentStats: {
      name: "GetEnrichmentStats",
      I: GetEnrichmentStatsRequest,
      O: GetEnrichmentStatsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.GetProductEnrichmentHistory
     */
    getProductEnrichmentHistory: {
      name: "GetProductEnrichmentHistory",
      I: GetProductEnrichmentHistoryRequest,
      O: GetProductEnrichmentHistoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Product mappings (competitor/supplier cross-reference)
     *
     * @generated from rpc omnios.v1.CatalogService.SuggestProductMappings
     */
    suggestProductMappings: {
      name: "SuggestProductMappings",
      I: SuggestProductMappingsRequest,
      O: SuggestProductMappingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ConfirmProductMapping
     */
    confirmProductMapping: {
      name: "ConfirmProductMapping",
      I: ConfirmProductMappingRequest,
      O: ConfirmProductMappingResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.DismissProductMapping
     */
    dismissProductMapping: {
      name: "DismissProductMapping",
      I: DismissProductMappingRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ListProductMappings
     */
    listProductMappings: {
      name: "ListProductMappings",
      I: ListProductMappingsRequest,
      O: ListProductMappingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.BulkConfirmMappings
     */
    bulkConfirmMappings: {
      name: "BulkConfirmMappings",
      I: BulkConfirmMappingsRequest,
      O: BulkConfirmMappingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Cross-reference engine
     *
     * @generated from rpc omnios.v1.CatalogService.CrossReferenceProducts
     */
    crossReferenceProducts: {
      name: "CrossReferenceProducts",
      I: CrossReferenceRequest,
      O: CrossReferenceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.GetCompetitorInsights
     */
    getCompetitorInsights: {
      name: "GetCompetitorInsights",
      I: GetCompetitorInsightsRequest,
      O: GetCompetitorInsightsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Catalog export/import
     *
     * @generated from rpc omnios.v1.CatalogService.ExportCatalog
     */
    exportCatalog: {
      name: "ExportCatalog",
      I: ExportCatalogRequest,
      O: ExportCatalogResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ImportCatalog
     */
    importCatalog: {
      name: "ImportCatalog",
      I: ImportCatalogRequest,
      O: ImportCatalogResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Property definition groups
     *
     * @generated from rpc omnios.v1.CatalogService.CreatePropertyGroup
     */
    createPropertyGroup: {
      name: "CreatePropertyGroup",
      I: CreatePropertyGroupRequest,
      O: PropertyDefinitionGroup,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ListPropertyGroups
     */
    listPropertyGroups: {
      name: "ListPropertyGroups",
      I: ListPropertyGroupsRequest,
      O: ListPropertyGroupsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.DeletePropertyGroup
     */
    deletePropertyGroup: {
      name: "DeletePropertyGroup",
      I: DeletePropertyGroupRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * Bulk attribute editing
     *
     * @generated from rpc omnios.v1.CatalogService.BulkSetProperties
     */
    bulkSetProperties: {
      name: "BulkSetProperties",
      I: BulkSetPropertiesRequest,
      O: BulkSetPropertiesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ExportProductsExcel
     */
    exportProductsExcel: {
      name: "ExportProductsExcel",
      I: ExportProductsExcelRequest,
      O: ExportProductsExcelResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ImportProductsExcel
     */
    importProductsExcel: {
      name: "ImportProductsExcel",
      I: ImportProductsExcelRequest,
      O: ImportProductsExcelResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Product versioning
     *
     * @generated from rpc omnios.v1.CatalogService.GetProductVersions
     */
    getProductVersions: {
      name: "GetProductVersions",
      I: GetProductVersionsRequest,
      O: GetProductVersionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.RestoreProductVersion
     */
    restoreProductVersion: {
      name: "RestoreProductVersion",
      I: RestoreProductVersionRequest,
      O: Product,
      kind: MethodKind.Unary,
    },
    /**
     * Channel syndication
     *
     * @generated from rpc omnios.v1.CatalogService.CreateSalesChannel
     */
    createSalesChannel: {
      name: "CreateSalesChannel",
      I: CreateSalesChannelRequest,
      O: SalesChannel,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.UpdateSalesChannel
     */
    updateSalesChannel: {
      name: "UpdateSalesChannel",
      I: UpdateSalesChannelRequest,
      O: SalesChannel,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.DeleteSalesChannel
     */
    deleteSalesChannel: {
      name: "DeleteSalesChannel",
      I: DeleteSalesChannelRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ListSalesChannels
     */
    listSalesChannels: {
      name: "ListSalesChannels",
      I: ListSalesChannelsRequest,
      O: ListSalesChannelsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.SetChannelMappings
     */
    setChannelMappings: {
      name: "SetChannelMappings",
      I: SetChannelMappingsRequest,
      O: SetChannelMappingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ListChannelMappings
     */
    listChannelMappings: {
      name: "ListChannelMappings",
      I: ListChannelMappingsRequest,
      O: ListChannelMappingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ExportToChannel
     */
    exportToChannel: {
      name: "ExportToChannel",
      I: ExportToChannelRequest,
      O: ExportToChannelResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Catalog completeness analytics
     *
     * @generated from rpc omnios.v1.CatalogService.GetCatalogCompleteness
     */
    getCatalogCompleteness: {
      name: "GetCatalogCompleteness",
      I: GetCatalogCompletenessRequest,
      O: GetCatalogCompletenessResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Multilingual content
     *
     * @generated from rpc omnios.v1.CatalogService.SetProductLocale
     */
    setProductLocale: {
      name: "SetProductLocale",
      I: SetProductLocaleRequest,
      O: ProductLocale,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ListProductLocales
     */
    listProductLocales: {
      name: "ListProductLocales",
      I: ListProductLocalesRequest,
      O: ListProductLocalesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.DeleteProductLocale
     */
    deleteProductLocale: {
      name: "DeleteProductLocale",
      I: DeleteProductLocaleRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * Supplier portal
     *
     * @generated from rpc omnios.v1.CatalogService.CreateSupplierDraft
     */
    createSupplierDraft: {
      name: "CreateSupplierDraft",
      I: CreateSupplierDraftRequest,
      O: SupplierProductDraft,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ListSupplierDrafts
     */
    listSupplierDrafts: {
      name: "ListSupplierDrafts",
      I: ListSupplierDraftsRequest,
      O: ListSupplierDraftsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ReviewSupplierDraft
     */
    reviewSupplierDraft: {
      name: "ReviewSupplierDraft",
      I: ReviewSupplierDraftRequest,
      O: ReviewSupplierDraftResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Field-level permissions
     *
     * @generated from rpc omnios.v1.CatalogService.SetFieldPermissions
     */
    setFieldPermissions: {
      name: "SetFieldPermissions",
      I: SetFieldPermissionsRequest,
      O: SetFieldPermissionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.GetFieldPermissions
     */
    getFieldPermissions: {
      name: "GetFieldPermissions",
      I: GetFieldPermissionsRequest,
      O: GetFieldPermissionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Classification standards
     *
     * @generated from rpc omnios.v1.CatalogService.ListClassificationStandards
     */
    listClassificationStandards: {
      name: "ListClassificationStandards",
      I: ListClassificationStandardsRequest,
      O: ListClassificationStandardsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ListClassificationCodes
     */
    listClassificationCodes: {
      name: "ListClassificationCodes",
      I: ListClassificationCodesRequest,
      O: ListClassificationCodesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.SetProductClassifications
     */
    setProductClassifications: {
      name: "SetProductClassifications",
      I: SetProductClassificationsRequest,
      O: SetProductClassificationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Structured bundles
     *
     * @generated from rpc omnios.v1.CatalogService.SetBundleItems
     */
    setBundleItems: {
      name: "SetBundleItems",
      I: SetBundleItemsRequest,
      O: SetBundleItemsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.ListBundleItems
     */
    listBundleItems: {
      name: "ListBundleItems",
      I: ListBundleItemsRequest,
      O: ListBundleItemsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Customer pricing (margin rules)
     *
     * @generated from rpc omnios.v1.CatalogService.GetCustomerPricingRule
     */
    getCustomerPricingRule: {
      name: "GetCustomerPricingRule",
      I: GetCustomerPricingRuleRequest,
      O: CustomerPricingRule,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.SetCustomerPricingRule
     */
    setCustomerPricingRule: {
      name: "SetCustomerPricingRule",
      I: SetCustomerPricingRuleRequest,
      O: CustomerPricingRule,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CatalogService.PreviewCustomerPricing
     */
    previewCustomerPricing: {
      name: "PreviewCustomerPricing",
      I: PreviewCustomerPricingRequest,
      O: PreviewCustomerPricingResponse,
      kind: MethodKind.Unary,
    },
  }
};

